(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('DialyserTypeSearch', DialyserTypeSearch);

    DialyserTypeSearch.$inject = ['$resource'];

    function DialyserTypeSearch($resource) {
        var resourceUrl =  'api/_search/dialyser-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
